import { IconNames } from "yadl-core-package";

export const AwsIconNames: IconNames = {
  aWSAppIntegrationAPIGateway: {
    name: "API Gateway",
    icon: "AWSAppIntegrationAPIGateway",
  },
  aWSAppIntegrationAppFlow: {
    name: "App Flow",
    icon: "AWSAppIntegrationAppFlow",
  },
  aWSAppIntegrationEventBridge: {
    name: "Event Bridge",
    icon: "AWSAppIntegrationEventBridge",
  },
  aWSAppIntegrationConsoleMobileApplication: {
    name: "Console Mobile Application",
    icon: "AWSAppIntegrationConsoleMobileApplication",
  },
  aWSAppIntegrationExpressWorkflows: {
    name: "Express Workflows",
    icon: "AWSAppIntegrationExpressWorkflows",
  },
  aWSAppIntegrationAppSync: {
    name: "App Sync",
    icon: "AWSAppIntegrationAppSync",
  },
  aWSAppIntegrationManagedWorkflowsforApacheAirflow: {
    name: "Managed Workflows for Apache Airflow",
    icon: "AWSAppIntegrationManagedWorkflowsforApacheAirflow",
  },
  aWSAppIntegrationMQ: { name: "MQ", icon: "AWSAppIntegrationMQ" },
  aWSAppIntegrationSimpleQueueService: {
    name: "Simple Queue Service",
    icon: "AWSAppIntegrationSimpleQueueService",
  },
  aWSAppIntegrationStepFunctions: {
    name: "Step Functions",
    icon: "AWSAppIntegrationStepFunctions",
  },
  aWSAppIntegrationSimpleNotificationService: {
    name: "Simple Notification Service",
    icon: "AWSAppIntegrationSimpleNotificationService",
  },
  aWSBusinessApplicationsChimeSDK: {
    name: "Chime SDK",
    icon: "AWSBusinessApplicationsChimeSDK",
  },
  aWSBusinessApplicationsChimeVoiceConnector: {
    name: "Chime Voice Connector",
    icon: "AWSBusinessApplicationsChimeVoiceConnector",
  },
  aWSBusinessApplicationsChime: {
    name: "Chime",
    icon: "AWSBusinessApplicationsChime",
  },
  aWSBusinessApplicationsPinpointAPIs: {
    name: "Pinpoint APIs",
    icon: "AWSBusinessApplicationsPinpointAPIs",
  },
  aWSBusinessApplicationsConnect: {
    name: "Connect",
    icon: "AWSBusinessApplicationsConnect",
  },
  aWSBusinessApplicationsPinpoint: {
    name: "Pinpoint",
    icon: "AWSBusinessApplicationsPinpoint",
  },
  aWSBusinessApplicationsSimpleEmailService: {
    name: "Simple Email Service",
    icon: "AWSBusinessApplicationsSimpleEmailService",
  },
  aWSBusinessApplicationsWickr: {
    name: "Wickr",
    icon: "AWSBusinessApplicationsWickr",
  },
  aWSBusinessApplicationsWorkDocsSDK: {
    name: "Work Docs SDK",
    icon: "AWSBusinessApplicationsWorkDocsSDK",
  },
  aWSBusinessApplicationsSupplyChain: {
    name: "Supply Chain",
    icon: "AWSBusinessApplicationsSupplyChain",
  },
  aWSBusinessApplicationsWorkDocs: {
    name: "Work Docs",
    icon: "AWSBusinessApplicationsWorkDocs",
  },
  aWSAnalyticsAthena: { name: "Athena", icon: "AWSAnalyticsAthena" },
  aWSBusinessApplicationsWorkMail: {
    name: "Work Mail",
    icon: "AWSBusinessApplicationsWorkMail",
  },
  aWSAnalyticsDataZone: { name: "Data Zone", icon: "AWSAnalyticsDataZone" },
  aWSAnalyticsDataPipeline: {
    name: "Data Pipeline",
    icon: "AWSAnalyticsDataPipeline",
  },
  aWSBusinessApplicationsAlexaForBusiness: {
    name: "Alexa For Business",
    icon: "AWSBusinessApplicationsAlexaForBusiness",
  },
  aWSAnalyticsCleanRooms: {
    name: "Clean Rooms",
    icon: "AWSAnalyticsCleanRooms",
  },
  aWSAnalyticsCloudSearch: {
    name: "Cloud Search",
    icon: "AWSAnalyticsCloudSearch",
  },
  aWSAnalyticsDataExchange: {
    name: "Data Exchange",
    icon: "AWSAnalyticsDataExchange",
  },
  aWSAnalyticsGlueDataBrew: {
    name: "Glue Data Brew",
    icon: "AWSAnalyticsGlueDataBrew",
  },
  aWSAnalyticsGlue: { name: "Glue", icon: "AWSAnalyticsGlue" },
  aWSAnalyticsKinesisDataAnalytics: {
    name: "Kinesis Data Analytics",
    icon: "AWSAnalyticsKinesisDataAnalytics",
  },
  aWSAnalyticsKinesisFirehose: {
    name: "Kinesis Firehose",
    icon: "AWSAnalyticsKinesisFirehose",
  },
  aWSAnalyticsKinesisVideoStreams: {
    name: "Kinesis Video Streams",
    icon: "AWSAnalyticsKinesisVideoStreams",
  },
  aWSAnalyticsKinesis: { name: "Kinesis", icon: "AWSAnalyticsKinesis" },
  aWSAnalyticsLakeFormation: {
    name: "Lake Formation",
    icon: "AWSAnalyticsLakeFormation",
  },
  aWSAnalyticsFinSpace: { name: "Fin Space", icon: "AWSAnalyticsFinSpace" },
  aWSAnalyticsManagedStreamingforApacheKafka: {
    name: "Managed Streaming for Apache Kafka",
    icon: "AWSAnalyticsManagedStreamingforApacheKafka",
  },
  aWSAnalyticsRedshift: { name: "Redshift", icon: "AWSAnalyticsRedshift" },
  aWSCloudFinancialManagementApplicationCostProfiler: {
    name: "Application Cost Profiler",
    icon: "AWSCloudFinancialManagementApplicationCostProfiler",
  },
  aWSCloudFinancialManagementBillingConductor: {
    name: "Billing Conductor",
    icon: "AWSCloudFinancialManagementBillingConductor",
  },
  aWSCloudFinancialManagementCostandUsageReport: {
    name: "Cost and Usage Report",
    icon: "AWSCloudFinancialManagementCostandUsageReport",
  },
  aWSCloudFinancialManagementCostExplorer: {
    name: "Cost Explorer",
    icon: "AWSCloudFinancialManagementCostExplorer",
  },
  aWSAnalyticsOpenSearchService: {
    name: "Open Search Service",
    icon: "AWSAnalyticsOpenSearchService",
  },
  aWSCloudFinancialManagementSavingsPlans: {
    name: "Savings Plans",
    icon: "AWSCloudFinancialManagementSavingsPlans",
  },
  aWSAnalyticsKinesisDataStreams: {
    name: "Kinesis Data Streams",
    icon: "AWSAnalyticsKinesisDataStreams",
  },
  aWSAnalyticsGlueElasticViews: {
    name: "Glue Elastic Views",
    icon: "AWSAnalyticsGlueElasticViews",
  },
  aWSCloudFinancialManagementReservedInstanceReporting: {
    name: "Reserved Instance Reporting",
    icon: "AWSCloudFinancialManagementReservedInstanceReporting",
  },
  aWSBlockchainManagedBlockchain: {
    name: "Managed Blockchain",
    icon: "AWSBlockchainManagedBlockchain",
  },
  aWSBlockchainQuantumLedgerDatabase: {
    name: "Quantum Ledger Database",
    icon: "AWSBlockchainQuantumLedgerDatabase",
  },
  aWSComputeApplicationAutoScaling: {
    name: "Application Auto Scaling",
    icon: "AWSComputeApplicationAutoScaling",
  },
  aWSComputeBottlerocket: {
    name: "Bottlerocket",
    icon: "AWSComputeBottlerocket",
  },
  aWSCloudFinancialManagementBudgets: {
    name: "Budgets",
    icon: "AWSCloudFinancialManagementBudgets",
  },
  aWSComputeComputeOptimizer: {
    name: "Compute Optimizer",
    icon: "AWSComputeComputeOptimizer",
  },
  aWSComputeEC2ImageBuilder: {
    name: "EC2 Image Builder",
    icon: "AWSComputeEC2ImageBuilder",
  },
  aWSComputeEC2AutoScaling: {
    name: "EC2 Auto Scaling",
    icon: "AWSComputeEC2AutoScaling",
  },
  aWSComputeEC2: { name: "EC2", icon: "AWSComputeEC2" },
  aWSComputeGenomicsCLI: {
    name: "Genomics CLI",
    icon: "AWSComputeGenomicsCLI",
  },
  aWSBusinessApplicationsHoneycode: {
    name: "Honeycode",
    icon: "AWSBusinessApplicationsHoneycode",
  },
  aWSComputeElasticFabricAdapter: {
    name: "Elastic Fabric Adapter",
    icon: "AWSComputeElasticFabricAdapter",
  },
  aWSComputeLocalZones: { name: "Local Zones", icon: "AWSComputeLocalZones" },
  aWSComputeLambda: { name: "Lambda", icon: "AWSComputeLambda" },
  aWSComputeAppRunner: { name: "App Runner", icon: "AWSComputeAppRunner" },
  aWSComputeNICEDCV: { name: "NICE DCV", icon: "AWSComputeNICEDCV" },
  aWSComputeNICEEnginFrame: {
    name: "NICE Engin Frame",
    icon: "AWSComputeNICEEnginFrame",
  },
  aWSComputeNitroEnclaves: {
    name: "Nitro Enclaves",
    icon: "AWSComputeNitroEnclaves",
  },
  aWSComputeOutpostsfamily: {
    name: "Outposts family",
    icon: "AWSComputeOutpostsfamily",
  },
  aWSComputeOutpostsrack: {
    name: "Outposts rack",
    icon: "AWSComputeOutpostsrack",
  },
  aWSAnalyticsEMR: { name: "EMR", icon: "AWSAnalyticsEMR" },
  aWSComputeSail: { name: "Sail", icon: "AWSComputeSail" },
  aWSComputeParallelCluster: {
    name: "Parallel Cluster",
    icon: "AWSComputeParallelCluster",
  },
  aWSComputeServerlessApplicationRepository: {
    name: "Serverless Application Repository",
    icon: "AWSComputeServerlessApplicationRepository",
  },
  aWSComputeBatch: { name: "Batch", icon: "AWSComputeBatch" },
  aWSComputeSimSpaceWeaver: {
    name: "Sim Space Weaver",
    icon: "AWSComputeSimSpaceWeaver",
  },
  aWSComputeThinkboxKrakatoa: {
    name: "Thinkbox Krakatoa",
    icon: "AWSComputeThinkboxKrakatoa",
  },
  aWSComputeThinkboxFrost: {
    name: "Thinkbox Frost",
    icon: "AWSComputeThinkboxFrost",
  },
  aWSComputeVMwareCloudonAWS: {
    name: "VMware Cloud on AWS",
    icon: "AWSComputeVMwareCloudonAWS",
  },
  aWSComputeThinkboxSequoia: {
    name: "Thinkbox Sequoia",
    icon: "AWSComputeThinkboxSequoia",
  },
  aWSComputeThinkboxStoke: {
    name: "Thinkbox Stoke",
    icon: "AWSComputeThinkboxStoke",
  },
  aWSComputeThinkboxXMesh: {
    name: "Thinkbox XMesh",
    icon: "AWSComputeThinkboxXMesh",
  },
  aWSComputeThinkboxDeadline: {
    name: "Thinkbox Deadline",
    icon: "AWSComputeThinkboxDeadline",
  },
  aWSComputeWavelength: { name: "Wavelength", icon: "AWSComputeWavelength" },
  aWSContainersEKSCloud: { name: "EKS Cloud", icon: "AWSContainersEKSCloud" },
  aWSComputeOutpostsservers: {
    name: "Outposts servers",
    icon: "AWSComputeOutpostsservers",
  },
  aWSComputeFargate: { name: "Fargate", icon: "AWSComputeFargate" },
  aWSComputeElasticBeanstalk: {
    name: "Elastic Beanstalk",
    icon: "AWSComputeElasticBeanstalk",
  },
  aWSContainersECSAnywhere: {
    name: "ECS Anywhere",
    icon: "AWSContainersECSAnywhere",
  },
  aWSContainersElasticKubernetesService: {
    name: "Elastic Kubernetes Service",
    icon: "AWSContainersElasticKubernetesService",
  },
  aWSContainersElasticContainerService: {
    name: "Elastic Container Service",
    icon: "AWSContainersElasticContainerService",
  },
  aWSCustomerEnablementActivate: {
    name: "Activate",
    icon: "AWSCustomerEnablementActivate",
  },
  aWSContainersFargate: { name: "Fargate", icon: "AWSContainersFargate" },
  aWSAnalyticsQuickSight: {
    name: "Quick Sight",
    icon: "AWSAnalyticsQuickSight",
  },
  aWSCustomerEnablementIQ: { name: "IQ", icon: "AWSCustomerEnablementIQ" },
  aWSContainersRedHatOpenShiftServiceonAWS: {
    name: "Red Hat Open Shift Service on AWS",
    icon: "AWSContainersRedHatOpenShiftServiceonAWS",
  },
  aWSContainersElasticContainerRegistry: {
    name: "Elastic Container Registry",
    icon: "AWSContainersElasticContainerRegistry",
  },
  aWSCustomerEnablementManagedServices: {
    name: "Managed Services",
    icon: "AWSCustomerEnablementManagedServices",
  },
  aWSCustomerEnablementSupport: {
    name: "Support",
    icon: "AWSCustomerEnablementSupport",
  },
  aWSCustomerEnablementTrainingCertification: {
    name: "Training Certification",
    icon: "AWSCustomerEnablementTrainingCertification",
  },
  aWSCustomerEnablementRePost: {
    name: "Re Post",
    icon: "AWSCustomerEnablementRePost",
  },
  aWSContainersEKSAnywhere: {
    name: "EKS Anywhere",
    icon: "AWSContainersEKSAnywhere",
  },
  aWSDatabaseDatabaseMigrationService: {
    name: "Database Migration Service",
    icon: "AWSDatabaseDatabaseMigrationService",
  },
  aWSDatabaseElastiCache: {
    name: "Elasti Cache",
    icon: "AWSDatabaseElastiCache",
  },
  aWSDatabaseKeyspaces: { name: "Keyspaces", icon: "AWSDatabaseKeyspaces" },
  aWSDatabaseMemoryDBforRedis: {
    name: "Memory DB for Redis",
    icon: "AWSDatabaseMemoryDBforRedis",
  },
  aWSDatabaseAurora: { name: "Aurora", icon: "AWSDatabaseAurora" },
  aWSDatabaseNeptune: { name: "Neptune", icon: "AWSDatabaseNeptune" },
  aWSDatabaseRDSonVMware: {
    name: "RDS on VMware",
    icon: "AWSDatabaseRDSonVMware",
  },
  aWSDatabaseTimestream: { name: "Timestream", icon: "AWSDatabaseTimestream" },
  aWSContainersEKSDistro: {
    name: "EKS Distro",
    icon: "AWSContainersEKSDistro",
  },
  aWSDatabaseDocumentDB: {
    name: "Document DB",
    icon: "AWSDatabaseDocumentDB",
  },
  aWSFrontEndWebMobileAmplify: {
    name: "Amplify",
    icon: "AWSFrontEndWebMobileAmplify",
  },
  aWSFrontEndWebMobileDeviceFarm: {
    name: "Device Farm",
    icon: "AWSFrontEndWebMobileDeviceFarm",
  },
  aWSFrontEndWebMobileLocationService: {
    name: "Location Service",
    icon: "AWSFrontEndWebMobileLocationService",
  },
  aWSDeveloperToolsApplicationComposer: {
    name: "Application Composer",
    icon: "AWSDeveloperToolsApplicationComposer",
  },
  aWSDeveloperToolsCloudDevelopmentKit: {
    name: "Cloud Development Kit",
    icon: "AWSDeveloperToolsCloudDevelopmentKit",
  },
  aWSDeveloperToolsCloudShell: {
    name: "Cloud Shell",
    icon: "AWSDeveloperToolsCloudShell",
  },
  aWSDatabaseDynamoDB: { name: "Dynamo DB", icon: "AWSDatabaseDynamoDB" },
  aWSDeveloperToolsCodeArtifact: {
    name: "Code Artifact",
    icon: "AWSDeveloperToolsCodeArtifact",
  },
  aWSDeveloperToolsCloud9: { name: "Cloud9", icon: "AWSDeveloperToolsCloud9" },
  aWSDeveloperToolsCodeBuild: {
    name: "Code Build",
    icon: "AWSDeveloperToolsCodeBuild",
  },
  aWSDeveloperToolsCodeCatalyst: {
    name: "Code Catalyst",
    icon: "AWSDeveloperToolsCodeCatalyst",
  },
  aWSDeveloperToolsCodeCommit: {
    name: "Code Commit",
    icon: "AWSDeveloperToolsCodeCommit",
  },
  aWSDeveloperToolsCloudControlAPI: {
    name: "Cloud Control API",
    icon: "AWSDeveloperToolsCloudControlAPI",
  },
  aWSDatabaseRDS: { name: "RDS", icon: "AWSDatabaseRDS" },
  aWSCustomerEnablementProfessionalServices: {
    name: "Professional Services",
    icon: "AWSCustomerEnablementProfessionalServices",
  },
  aWSDeveloperToolsCodePipeline: {
    name: "Code Pipeline",
    icon: "AWSDeveloperToolsCodePipeline",
  },
  aWSDeveloperToolsCommandLineInterface: {
    name: "Command Line Interface",
    icon: "AWSDeveloperToolsCommandLineInterface",
  },
  aWSDeveloperToolsToolsandSDKs: {
    name: "Tools and SDKs",
    icon: "AWSDeveloperToolsToolsandSDKs",
  },
  aWSDeveloperToolsCodeStar: {
    name: "Code Star",
    icon: "AWSDeveloperToolsCodeStar",
  },
  aWSDeveloperToolsCodeDeploy: {
    name: "Code Deploy",
    icon: "AWSDeveloperToolsCodeDeploy",
  },
  aWSDeveloperToolsXRay: { name: "X Ray", icon: "AWSDeveloperToolsXRay" },
  aWSGeneralIconsMarketplace_Dark: {
    name: "Marketplace Dark",
    icon: "AWSGeneralIconsMarketplace_Dark",
  },
  aWSGeneralIconsMarketplace_: {
    name: "Marketplace",
    icon: "AWSGeneralIconsMarketplace_",
  },
  aWSGamesGameKit: { name: "Game Kit", icon: "AWSGamesGameKit" },
  aWSGamesGameSparks: { name: "Game Sparks", icon: "AWSGamesGameSparks" },
  aWSGamesLumberyard: { name: "Lumberyard", icon: "AWSGamesLumberyard" },
  aWSGamesGameLift: { name: "Game Lift", icon: "AWSGamesGameLift" },
  aWSEndUserComputingAppStream: {
    name: "App Stream",
    icon: "AWSEndUserComputingAppStream",
  },
  aWSEndUserComputingWorkLink: {
    name: "Work Link",
    icon: "AWSEndUserComputingWorkLink",
  },
  aWSEndUserComputingWorkSpacesFamily: {
    name: "Work Spaces Family",
    icon: "AWSEndUserComputingWorkSpacesFamily",
  },
  aWSGamesOpen3DEngine: {
    name: "Open 3D Engine",
    icon: "AWSGamesOpen3DEngine",
  },
  aWSDeveloperToolsCorretto: {
    name: "Corretto",
    icon: "AWSDeveloperToolsCorretto",
  },
  aWSInternetofThingsFreeRTOS: {
    name: "Free RTOS",
    icon: "AWSInternetofThingsFreeRTOS",
  },
  aWSInternetofThingsIoTAnalytics: {
    name: "IoT Analytics",
    icon: "AWSInternetofThingsIoTAnalytics",
  },
  aWSInternetofThingsIoTButton: {
    name: "IoT Button",
    icon: "AWSInternetofThingsIoTButton",
  },
  aWSInternetofThingsIoT1Click: {
    name: "IoT 1 Click",
    icon: "AWSInternetofThingsIoT1Click",
  },
  aWSInternetofThingsIoTCore: {
    name: "IoT Core",
    icon: "AWSInternetofThingsIoTCore",
  },
  aWSInternetofThingsIoTDeviceDefender: {
    name: "IoT Device Defender",
    icon: "AWSInternetofThingsIoTDeviceDefender",
  },
  aWSInternetofThingsIoTEduKit: {
    name: "IoT Edu Kit",
    icon: "AWSInternetofThingsIoTEduKit",
  },
  aWSInternetofThingsIoTDeviceManagement: {
    name: "IoT Device Management",
    icon: "AWSInternetofThingsIoTDeviceManagement",
  },
  aWSInternetofThingsIoTEvents: {
    name: "IoT Events",
    icon: "AWSInternetofThingsIoTEvents",
  },
  aWSInternetofThingsIoTGreengrass: {
    name: "IoT Greengrass",
    icon: "AWSInternetofThingsIoTGreengrass",
  },
  aWSInternetofThingsIoTSiteWise: {
    name: "IoT Site Wise",
    icon: "AWSInternetofThingsIoTSiteWise",
  },
  aWSInternetofThingsIoTExpressLink: {
    name: "IoT Express Link",
    icon: "AWSInternetofThingsIoTExpressLink",
  },
  aWSInternetofThingsIoTThingsGraph: {
    name: "IoT Things Graph",
    icon: "AWSInternetofThingsIoTThingsGraph",
  },
  aWSInternetofThingsIoTTwinMaker: {
    name: "IoT Twin Maker",
    icon: "AWSInternetofThingsIoTTwinMaker",
  },
  aWSMachineLearningComprehendMedical: {
    name: "Comprehend Medical",
    icon: "AWSMachineLearningComprehendMedical",
  },
  aWSMachineLearningApacheMXNetonAWS: {
    name: "Apache MX Net on AWS",
    icon: "AWSMachineLearningApacheMXNetonAWS",
  },
  aWSInternetofThingsIoTRoboRunner: {
    name: "IoT Robo Runner",
    icon: "AWSInternetofThingsIoTRoboRunner",
  },
  aWSMachineLearningCodeWhisperer: {
    name: "Code Whisperer",
    icon: "AWSMachineLearningCodeWhisperer",
  },
  aWSInternetofThingsIoTFleetWise: {
    name: "IoT Fleet Wise",
    icon: "AWSInternetofThingsIoTFleetWise",
  },
  aWSMachineLearningComprehend: {
    name: "Comprehend",
    icon: "AWSMachineLearningComprehend",
  },
  aWSMachineLearningDeepComposer: {
    name: "Deep Composer",
    icon: "AWSMachineLearningDeepComposer",
  },
  aWSMachineLearningDeepLearningContainers: {
    name: "Deep Learning Containers",
    icon: "AWSMachineLearningDeepLearningContainers",
  },
  aWSMachineLearningDeepRacer: {
    name: "Deep Racer",
    icon: "AWSMachineLearningDeepRacer",
  },
  aWSMachineLearningDeepLens: {
    name: "Deep Lens",
    icon: "AWSMachineLearningDeepLens",
  },
  aWSMachineLearningElasticInference: {
    name: "Elastic Inference",
    icon: "AWSMachineLearningElasticInference",
  },
  aWSMachineLearningForecast: {
    name: "Forecast",
    icon: "AWSMachineLearningForecast",
  },
  aWSMachineLearningDeepLearningAMIs: {
    name: "Deep Learning AMIs",
    icon: "AWSMachineLearningDeepLearningAMIs",
  },
  aWSMachineLearningHealthLake: {
    name: "Health Lake",
    icon: "AWSMachineLearningHealthLake",
  },
  aWSMachineLearningAugmentedAIA2I: {
    name: "Augmented AI A2I",
    icon: "AWSMachineLearningAugmentedAIA2I",
  },
  aWSMachineLearningKendra: {
    name: "Kendra",
    icon: "AWSMachineLearningKendra",
  },
  aWSMachineLearningLookoutforEquipment: {
    name: "Lookout for Equipment",
    icon: "AWSMachineLearningLookoutforEquipment",
  },
  aWSMachineLearningLookoutforMetrics: {
    name: "Lookout for Metrics",
    icon: "AWSMachineLearningLookoutforMetrics",
  },
  aWSMachineLearningCodeGuru: {
    name: "Code Guru",
    icon: "AWSMachineLearningCodeGuru",
  },
  aWSMachineLearningLex: { name: "Lex", icon: "AWSMachineLearningLex" },
  aWSMachineLearningLookoutforVision: {
    name: "Lookout for Vision",
    icon: "AWSMachineLearningLookoutforVision",
  },
  aWSMachineLearningMonitron: {
    name: "Monitron",
    icon: "AWSMachineLearningMonitron",
  },
  aWSMachineLearningOmics: { name: "Omics", icon: "AWSMachineLearningOmics" },
  aWSMachineLearningPersonalize: {
    name: "Personalize",
    icon: "AWSMachineLearningPersonalize",
  },
  aWSMachineLearningDevOpsGuru: {
    name: "Dev Ops Guru",
    icon: "AWSMachineLearningDevOpsGuru",
  },
  aWSMachineLearningSageMakerStudioLab: {
    name: "Sage Maker Studio Lab",
    icon: "AWSMachineLearningSageMakerStudioLab",
  },
  aWSMachineLearningPanorama: {
    name: "Panorama",
    icon: "AWSMachineLearningPanorama",
  },
  aWSMachineLearningSageMaker: {
    name: "Sage Maker",
    icon: "AWSMachineLearningSageMaker",
  },
  aWSMachineLearningFraudDetector: {
    name: "Fraud Detector",
    icon: "AWSMachineLearningFraudDetector",
  },
  aWSMachineLearningRekognition: {
    name: "Rekognition",
    icon: "AWSMachineLearningRekognition",
  },
  aWSMachineLearningTorchServe: {
    name: "Torch Serve",
    icon: "AWSMachineLearningTorchServe",
  },
  aWSMachineLearningTextract: {
    name: "Textract",
    icon: "AWSMachineLearningTextract",
  },
  aWSMachineLearningNeuron: {
    name: "Neuron",
    icon: "AWSMachineLearningNeuron",
  },
  aWSMachineLearningTensorFlowonAWS: {
    name: "Tensor Flow on AWS",
    icon: "AWSMachineLearningTensorFlowonAWS",
  },
  aWSMachineLearningTranscribe: {
    name: "Transcribe",
    icon: "AWSMachineLearningTranscribe",
  },
  aWSMigrationTransferApplicationDiscoveryService: {
    name: "Application Discovery Service",
    icon: "AWSMigrationTransferApplicationDiscoveryService",
  },
  aWSMachineLearningTranslate: {
    name: "Translate",
    icon: "AWSMachineLearningTranslate",
  },
  aWSMigrationTransferDataSync: {
    name: "Data Sync",
    icon: "AWSMigrationTransferDataSync",
  },
  aWSMachineLearningSageMakerGroundTruth: {
    name: "Sage Maker Ground Truth",
    icon: "AWSMachineLearningSageMakerGroundTruth",
  },
  aWSMigrationTransferMainframeModernization: {
    name: "Mainframe Modernization",
    icon: "AWSMigrationTransferMainframeModernization",
  },
  aWSMigrationTransferServerMigrationService: {
    name: "Server Migration Service",
    icon: "AWSMigrationTransferServerMigrationService",
  },
  aWSMigrationTransferApplicationMigrationService: {
    name: "Application Migration Service",
    icon: "AWSMigrationTransferApplicationMigrationService",
  },
  aWSMigrationTransferTransferFamily: {
    name: "Transfer Family",
    icon: "AWSMigrationTransferTransferFamily",
  },
  aWSNetworkingContentDeliveryAppMesh: {
    name: "App Mesh",
    icon: "AWSNetworkingContentDeliveryAppMesh",
  },
  aWSNetworkingContentDeliveryCloudDirectory: {
    name: "Cloud Directory",
    icon: "AWSNetworkingContentDeliveryCloudDirectory",
  },
  aWSNetworkingContentDeliveryCloudMap: {
    name: "Cloud Map",
    icon: "AWSNetworkingContentDeliveryCloudMap",
  },
  aWSMigrationTransferMigrationHub: {
    name: "Migration Hub",
    icon: "AWSMigrationTransferMigrationHub",
  },
  aWSMigrationTransferMigrationEvaluator: {
    name: "Migration Evaluator",
    icon: "AWSMigrationTransferMigrationEvaluator",
  },
  aWSNetworkingContentDeliveryCloudWAN: {
    name: "Cloud WAN",
    icon: "AWSNetworkingContentDeliveryCloudWAN",
  },
  aWSNetworkingContentDeliveryClientVPN: {
    name: "Client VPN",
    icon: "AWSNetworkingContentDeliveryClientVPN",
  },
  aWSNetworkingContentDeliveryCloudFront: {
    name: "Cloud Front",
    icon: "AWSNetworkingContentDeliveryCloudFront",
  },
  aWSNetworkingContentDeliveryGlobalAccelerator: {
    name: "Global Accelerator",
    icon: "AWSNetworkingContentDeliveryGlobalAccelerator",
  },
  aWSNetworkingContentDeliveryElasticLoadBalancing: {
    name: "Elastic Load Balancing",
    icon: "AWSNetworkingContentDeliveryElasticLoadBalancing",
  },
  aWSNetworkingContentDeliveryRoute53: {
    name: "Route 53",
    icon: "AWSNetworkingContentDeliveryRoute53",
  },
  aWSNetworkingContentDeliveryPrivateLink: {
    name: "Private Link",
    icon: "AWSNetworkingContentDeliveryPrivateLink",
  },
  aWSNetworkingContentDeliverySitetoSiteVPN: {
    name: "Site to Site VPN",
    icon: "AWSNetworkingContentDeliverySitetoSiteVPN",
  },
  aWSNetworkingContentDeliveryPrivate5G: {
    name: "Private 5G",
    icon: "AWSNetworkingContentDeliveryPrivate5G",
  },
  aWSNetworkingContentDeliveryDirectConnect: {
    name: "Direct Connect",
    icon: "AWSNetworkingContentDeliveryDirectConnect",
  },
  aWSNetworkingContentDeliveryTransitGateway: {
    name: "Transit Gateway",
    icon: "AWSNetworkingContentDeliveryTransitGateway",
  },
  aWSNetworkingContentDeliveryVPCLattice: {
    name: "VPC Lattice",
    icon: "AWSNetworkingContentDeliveryVPCLattice",
  },
  aWSRoboticsRoboMaker: { name: "Robo Maker", icon: "AWSRoboticsRoboMaker" },
  aWSNetworkingContentDeliveryVirtualPrivateCloud: {
    name: "Virtual Private Cloud",
    icon: "AWSNetworkingContentDeliveryVirtualPrivateCloud",
  },
  aWSNetworkingContentDeliveryVerifiedAccess: {
    name: "Verified Access",
    icon: "AWSNetworkingContentDeliveryVerifiedAccess",
  },
  aWSStorageBackup: { name: "Backup", icon: "AWSStorageBackup" },
  aWSQuantumTechnologiesBraket: {
    name: "Braket",
    icon: "AWSQuantumTechnologiesBraket",
  },
  aWSStorageElasticBlockStore: {
    name: "Elastic Block Store",
    icon: "AWSStorageElasticBlockStore",
  },
  aWSStorageEFS: { name: "EFS", icon: "AWSStorageEFS" },
  aWSStorageElasticDisasterRecovery: {
    name: "Elastic Disaster Recovery",
    icon: "AWSStorageElasticDisasterRecovery",
  },
  aWSStorageFSxforNetAppONTAP: {
    name: "FSx for Net App ONTAP",
    icon: "AWSStorageFSxforNetAppONTAP",
  },
  aWSStorageFSx: { name: "FSx", icon: "AWSStorageFSx" },
  aWSStorageFileCache: { name: "File Cache", icon: "AWSStorageFileCache" },
  aWSMachineLearningPolly: { name: "Polly", icon: "AWSMachineLearningPolly" },
  aWSStorageS3onOutposts: {
    name: "S3 on Outposts",
    icon: "AWSStorageS3onOutposts",
  },
  aWSStorageFSxforLustre: {
    name: "FSx for Lustre",
    icon: "AWSStorageFSxforLustre",
  },
  aWSStorageSimpleStorageServiceGlacier: {
    name: "Simple Storage Service Glacier",
    icon: "AWSStorageSimpleStorageServiceGlacier",
  },
  aWSStorageSnowballEdge: {
    name: "Snowball Edge",
    icon: "AWSStorageSnowballEdge",
  },
  aWSStorageFSxforWFS: { name: "FSx for WFS", icon: "AWSStorageFSxforWFS" },
  aWSStorageSnowcone: { name: "Snowcone", icon: "AWSStorageSnowcone" },
  aWSStorageStorageGateway: {
    name: "Storage Gateway",
    icon: "AWSStorageStorageGateway",
  },
  aWSStorageFSxforOpenZFS: {
    name: "FSx for Open ZFS",
    icon: "AWSStorageFSxforOpenZFS",
  },
  aWSSatelliteGroundStation: {
    name: "Ground Station",
    icon: "AWSSatelliteGroundStation",
  },
  aWSStorageSimpleStorageService: {
    name: "Simple Storage Service",
    icon: "AWSStorageSimpleStorageService",
  },
  aWSStorageSnowmobile: { name: "Snowmobile", icon: "AWSStorageSnowmobile" },
  aWSManagementGovernanceAutoScaling: {
    name: "Auto Scaling",
    icon: "AWSManagementGovernanceAutoScaling",
  },
  aWSManagementGovernanceBackintAgent: {
    name: "Backint Agent",
    icon: "AWSManagementGovernanceBackintAgent",
  },
  aWSManagementGovernanceChatbot: {
    name: "Chatbot",
    icon: "AWSManagementGovernanceChatbot",
  },
  aWSStorageSnowball: { name: "Snowball", icon: "AWSStorageSnowball" },
  aWSManagementGovernanceCloudWatch: {
    name: "Cloud Watch",
    icon: "AWSManagementGovernanceCloudWatch",
  },
  aWSManagementGovernanceConfig: {
    name: "Config",
    icon: "AWSManagementGovernanceConfig",
  },
  aWSManagementGovernanceCloudFormation: {
    name: "Cloud Formation",
    icon: "AWSManagementGovernanceCloudFormation",
  },
  aWSManagementGovernanceCloudTrail: {
    name: "Cloud Trail",
    icon: "AWSManagementGovernanceCloudTrail",
  },
  aWSManagementGovernanceControlTower: {
    name: "Control Tower",
    icon: "AWSManagementGovernanceControlTower",
  },
  aWSManagementGovernanceAppConfig: {
    name: "App Config",
    icon: "AWSManagementGovernanceAppConfig",
  },
  aWSManagementGovernanceLaunchWizard: {
    name: "Launch Wizard",
    icon: "AWSManagementGovernanceLaunchWizard",
  },
  aWSManagementGovernanceDistroforOpenTelemetry: {
    name: "Distro for Open Telemetry",
    icon: "AWSManagementGovernanceDistroforOpenTelemetry",
  },
  aWSManagementGovernanceApplicationAutoScaling: {
    name: "Application Auto Scaling",
    icon: "AWSManagementGovernanceApplicationAutoScaling",
  },
  aWSManagementGovernanceManagedGrafana: {
    name: "Managed Grafana",
    icon: "AWSManagementGovernanceManagedGrafana",
  },
  aWSManagementGovernanceOpsWorks: {
    name: "Ops Works",
    icon: "AWSManagementGovernanceOpsWorks",
  },
  aWSManagementGovernanceManagedServiceforPrometheus: {
    name: "Managed Service for Prometheus",
    icon: "AWSManagementGovernanceManagedServiceforPrometheus",
  },
  aWSManagementGovernanceOrganizations: {
    name: "Organizations",
    icon: "AWSManagementGovernanceOrganizations",
  },
  aWSManagementGovernanceResilienceHub: {
    name: "Resilience Hub",
    icon: "AWSManagementGovernanceResilienceHub",
  },
  aWSManagementGovernanceProton: {
    name: "Proton",
    icon: "AWSManagementGovernanceProton",
  },
  aWSManagementGovernanceServiceCatalog: {
    name: "Service Catalog",
    icon: "AWSManagementGovernanceServiceCatalog",
  },
  aWSManagementGovernanceLicenseManager: {
    name: "License Manager",
    icon: "AWSManagementGovernanceLicenseManager",
  },
  aWSManagementGovernanceServiceManagementConnector: {
    name: "Service Management Connector",
    icon: "AWSManagementGovernanceServiceManagementConnector",
  },
  aWSManagementGovernanceTrustedAdvisor: {
    name: "Trusted Advisor",
    icon: "AWSManagementGovernanceTrustedAdvisor",
  },
  aWSMediaServicesElasticTranscoder: {
    name: "Elastic Transcoder",
    icon: "AWSMediaServicesElasticTranscoder",
  },
  aWSVRARSumerian: { name: "Sumerian", icon: "AWSVRARSumerian" },
  aWSMediaServicesElementalAppliancesSoftware: {
    name: "Elemental Appliances & Software",
    icon: "AWSMediaServicesElementalAppliancesSoftware",
  },
  aWSManagementGovernanceManagementConsole: {
    name: "Management Console",
    icon: "AWSManagementGovernanceManagementConsole",
  },
  aWSMediaServicesElementalDelta: {
    name: "Elemental Delta",
    icon: "AWSMediaServicesElementalDelta",
  },
  aWSManagementGovernanceWellArchitectedTool: {
    name: "Well Architected Tool",
    icon: "AWSManagementGovernanceWellArchitectedTool",
  },
  aWSManagementGovernanceFaultInjectionSimulator: {
    name: "Fault Injection Simulator",
    icon: "AWSManagementGovernanceFaultInjectionSimulator",
  },
  aWSMediaServicesElementalConductor: {
    name: "Elemental Conductor",
    icon: "AWSMediaServicesElementalConductor",
  },
  aWSMediaServicesElementalLink: {
    name: "Elemental Link",
    icon: "AWSMediaServicesElementalLink",
  },
  aWSManagementGovernanceSystemsManager: {
    name: "Systems Manager",
    icon: "AWSManagementGovernanceSystemsManager",
  },
  aWSManagementGovernancePersonalHealthDashboard: {
    name: "Personal Health Dashboard",
    icon: "AWSManagementGovernancePersonalHealthDashboard",
  },
  aWSMediaServicesElementalMediaConvert: {
    name: "Elemental Media Convert",
    icon: "AWSMediaServicesElementalMediaConvert",
  },
  aWSMediaServicesElementalMediaPackage: {
    name: "Elemental Media Package",
    icon: "AWSMediaServicesElementalMediaPackage",
  },
  aWSMediaServicesElementalMediaStore: {
    name: "Elemental Media Store",
    icon: "AWSMediaServicesElementalMediaStore",
  },
  aWSMediaServicesElementalMediaLive: {
    name: "Elemental Media Live",
    icon: "AWSMediaServicesElementalMediaLive",
  },
  aWSMediaServicesElementalMediaConnect: {
    name: "Elemental Media Connect",
    icon: "AWSMediaServicesElementalMediaConnect",
  },
  aWSMediaServicesInteractiveVideoService: {
    name: "Interactive Video Service",
    icon: "AWSMediaServicesInteractiveVideoService",
  },
  aWSMediaServicesElementalServer: {
    name: "Elemental Server",
    icon: "AWSMediaServicesElementalServer",
  },
  aWSMediaServicesKinesisVideoStreams: {
    name: "Kinesis Video Streams",
    icon: "AWSMediaServicesKinesisVideoStreams",
  },
  aWSSecurityIdentityComplianceArtifact: {
    name: "Artifact",
    icon: "AWSSecurityIdentityComplianceArtifact",
  },
  aWSSecurityIdentityComplianceCloudHSM: {
    name: "Cloud HSM",
    icon: "AWSSecurityIdentityComplianceCloudHSM",
  },
  aWSSecurityIdentityComplianceAuditManager: {
    name: "Audit Manager",
    icon: "AWSSecurityIdentityComplianceAuditManager",
  },
  aWSMediaServicesElementalMediaTailor: {
    name: "Elemental Media Tailor",
    icon: "AWSMediaServicesElementalMediaTailor",
  },
  aWSSecurityIdentityComplianceCertificateManager: {
    name: "Certificate Manager",
    icon: "AWSSecurityIdentityComplianceCertificateManager",
  },
  aWSSecurityIdentityComplianceCloudDirectory: {
    name: "Cloud Directory",
    icon: "AWSSecurityIdentityComplianceCloudDirectory",
  },
  aWSSecurityIdentityComplianceDirectoryService: {
    name: "Directory Service",
    icon: "AWSSecurityIdentityComplianceDirectoryService",
  },
  aWSSecurityIdentityComplianceDetective: {
    name: "Detective",
    icon: "AWSSecurityIdentityComplianceDetective",
  },
  aWSSecurityIdentityComplianceFirewallManager: {
    name: "Firewall Manager",
    icon: "AWSSecurityIdentityComplianceFirewallManager",
  },
  aWSMediaServicesElementalLive: {
    name: "Elemental Live",
    icon: "AWSMediaServicesElementalLive",
  },
  aWSSecurityIdentityComplianceCognito: {
    name: "Cognito",
    icon: "AWSSecurityIdentityComplianceCognito",
  },
  aWSSecurityIdentityComplianceIdentityandAccessManagement: {
    name: "Identity and Access Management",
    icon: "AWSSecurityIdentityComplianceIdentityandAccessManagement",
  },
  aWSSecurityIdentityComplianceInspector: {
    name: "Inspector",
    icon: "AWSSecurityIdentityComplianceInspector",
  },
  aWSManagementGovernanceResourceExplorer: {
    name: "Resource Explorer",
    icon: "AWSManagementGovernanceResourceExplorer",
  },
  aWSSecurityIdentityComplianceResourceAccessManager: {
    name: "Resource Access Manager",
    icon: "AWSSecurityIdentityComplianceResourceAccessManager",
  },
  aWSMediaServicesNimbleStudio: {
    name: "Nimble Studio",
    icon: "AWSMediaServicesNimbleStudio",
  },
  aWSSecurityIdentityComplianceSecurityHub: {
    name: "Security Hub",
    icon: "AWSSecurityIdentityComplianceSecurityHub",
  },
  aWSSecurityIdentityComplianceSecurityLake: {
    name: "Security Lake",
    icon: "AWSSecurityIdentityComplianceSecurityLake",
  },
  aWSSecurityIdentityComplianceVerifiedPermissions: {
    name: "Verified Permissions",
    icon: "AWSSecurityIdentityComplianceVerifiedPermissions",
  },
  aWSSecurityIdentityComplianceShield: {
    name: "Shield",
    icon: "AWSSecurityIdentityComplianceShield",
  },
  aWSSecurityIdentityComplianceIAMIdentityCenter: {
    name: "IAM Identity Center",
    icon: "AWSSecurityIdentityComplianceIAMIdentityCenter",
  },
  aWSSecurityIdentityComplianceNetworkFirewall: {
    name: "Network Firewall",
    icon: "AWSSecurityIdentityComplianceNetworkFirewall",
  },
  aWSSecurityIdentityComplianceMacie: {
    name: "Macie",
    icon: "AWSSecurityIdentityComplianceMacie",
  },
  aWSSecurityIdentityCompliancePrivateCertificateAuthority: {
    name: "Private Certificate Authority",
    icon: "AWSSecurityIdentityCompliancePrivateCertificateAuthority",
  },
  aWSSecurityIdentityComplianceKeyManagementService: {
    name: "Key Management Service",
    icon: "AWSSecurityIdentityComplianceKeyManagementService",
  },
  aWSSecurityIdentityComplianceGuardDuty: {
    name: "Guard Duty",
    icon: "AWSSecurityIdentityComplianceGuardDuty",
  },
  aWSSecurityIdentityComplianceSigner: {
    name: "Signer",
    icon: "AWSSecurityIdentityComplianceSigner",
  },
  aWSSecurityIdentityComplianceWAF: {
    name: "WAF",
    icon: "AWSSecurityIdentityComplianceWAF",
  },
  aWSSecurityIdentityComplianceSecretsManager: {
    name: "Secrets Manager",
    icon: "AWSSecurityIdentityComplianceSecretsManager",
  },
};
